<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <record-select-group v-model="teamId1" label="Home team" :dataset-id="datasetId"
                           v-if="datasetId"></record-select-group>
      <text-input-group v-model="name1" label="Home name"></text-input-group>
      <picture-select-group v-model="teamImageId1" :album-id="albumId" label="Home logo"></picture-select-group>
      <hr>
      <record-select-group v-model="teamId2" label="Away team" :dataset-id="datasetId"
                           v-if="datasetId"></record-select-group>
      <text-input-group v-model="name2" label="Away name"></text-input-group>
      <picture-select-group v-model="teamImageId2" :album-id="albumId" label="Away logo"></picture-select-group>
      <hr>
      <text-input-group v-model="topLeftText" label="Top left text"></text-input-group>
      <picture-select-group v-model="topLeftImageId" :album-id="albumId" label="Top left image"></picture-select-group>
      <text-input-group v-model="topRightText" label="Top right"></text-input-group>
      <picture-select-group v-model="topRightImageId" :album-id="albumId"
                            label="Top right image"></picture-select-group>
      <text-input-group v-model="bottomLeftText" label="Bottom left"></text-input-group>
      <picture-select-group v-model="bottomLeftImageId" :album-id="albumId"
                            label="Bottom left image"></picture-select-group>
      <text-input-group v-model="bottomRightText" label="Bottom right"></text-input-group>
      <picture-select-group v-model="bottomRightImageId" :album-id="albumId"
                            label="Bottom right image"></picture-select-group>
    </window-tab>
    <window-tab title="Data" icon="database">
      <dataset-select-group v-model="datasetId" label="Teams" :show-fields="true"></dataset-select-group>
      <text-input-group v-model="patternName" label="Name"></text-input-group>
      <text-input-group v-model="patternPicture" label="Picture"></text-input-group>
      <album-select-group v-model="albumId" label="Pictures"></album-select-group>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapImageIdToImage, mapOverlayData, mapRecord, mapTemplateData } from '../../utils/index'

  export default {
    name: 'match-title',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['name1', 'name2']),
      ...mapOverlayData(['topLeftText', 'topRightText', 'bottomLeftText', 'bottomRightText']),
      ...mapTemplateData(['topLeftImageId', 'topRightImageId', 'bottomLeftImageId', 'bottomRightImageId']),
      ...mapTemplateData(['albumId', 'datasetId', 'teamId1', 'teamId2', 'teamImageId1', 'teamImageId2']),
      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        patternName: {default: '${NAME}'},
        patternPicture: {default: '${PICTURE}'}
        /* eslint-enable no-template-curly-in-string */
      })
    },
    watch: {
      teamId1: function (val) {
        const record = this.$store.getters.datasetRecord(this.datasetId, val) || null
        const values = mapRecord(record, {name: this.patternName, picture: this.patternPicture})
        this.name1 = values.name
        const picture = this.$store.getters.picture(this.albumId, p => p.fileName === values.picture)
        this.teamImageId1 = picture && picture.pictureId
      },
      teamId2: function (val) {
        const record = this.$store.getters.datasetRecord(this.datasetId, val) || null
        const values = mapRecord(record, {name: this.patternName, picture: this.patternPicture})
        this.name2 = values.name
        const picture = this.$store.getters.picture(this.albumId, p => p.fileName === values.picture)
        this.teamImageId2 = picture && picture.pictureId
      },
      ...mapImageIdToImage('albumId', 'teamImageId1', 'teamImage1'),
      ...mapImageIdToImage('albumId', 'teamImageId2', 'teamImage2'),
      ...mapImageIdToImage('albumId', 'topLeftImageId', 'topLeftImage'),
      ...mapImageIdToImage('albumId', 'topRightImageId', 'topRightImage'),
      ...mapImageIdToImage('albumId', 'bottomLeftImageId', 'bottomLeftImage'),
      ...mapImageIdToImage('albumId', 'bottomRightImageId', 'bottomRightImage')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/match-title.vue